import i18n from 'i18next';

import { InputTypes, PreprocessorTypes } from '@cashier/cashier-model';

import { ConfigurationEnricher } from './model';

const CARD_HOLDER_INPUT_NAME = 'cardHolder';
const CREDIT_CARD_NUMBER_INPUT_NAME = 'creditcardNumber';
const CVV_INPUT_NAME = 'cvv';
const EXPIRATION_DATE_INPUT_NAME = 'expirationDate';

export const TokenizerV1ConfigurationEnricher: ConfigurationEnricher = {
  shouldEnrich: (_, { preprocessor, currentAccount }) => {
    return (
      !!preprocessor &&
      preprocessor.type === PreprocessorTypes.TOKENIZER_V1 &&
      !currentAccount
    );
  },
  enrich: (configuration, _) => {
    configuration.set(CARD_HOLDER_INPUT_NAME, {
      name: CARD_HOLDER_INPUT_NAME,
      label: i18n.t('cardHolder.label'),
      required: true,
      type: InputTypes.Input,
      placeholder: i18n.t('cardHolder.placeholder'),
      value: null,
      params: {
        options: [],
        preprocessed: false,
        isUiOnly: true,
      },
    });

    configuration.set(CREDIT_CARD_NUMBER_INPUT_NAME, {
      name: CREDIT_CARD_NUMBER_INPUT_NAME,
      label: i18n.t('creditcardNumber.label'),
      required: true,
      type: InputTypes.CreditCardNumber,
      placeholder: i18n.t('creditcardNumber.placeholder'),
      value: null,
      params: {
        options: [],
        preprocessed: true,
        isUiOnly: true,
      },
    });

    configuration.set(CVV_INPUT_NAME, {
      name: CVV_INPUT_NAME,
      label: i18n.t('cvv.label'),
      required: true,
      type: InputTypes.Cvv,
      placeholder: i18n.t('cvv.placeholder'),
      value: null,
      params: {
        options: [],
        preprocessed: true,
        isUiOnly: true,
      },
    });

    configuration.set(EXPIRATION_DATE_INPUT_NAME, {
      name: EXPIRATION_DATE_INPUT_NAME,
      label: i18n.t('expirationDate.label'),
      required: true,
      type: InputTypes.DateTime,
      placeholder: i18n.t('expirationDate.placeholder'),
      value: null,
      mask: '99/99',
      params: {
        options: [],
        preprocessed: true,
        isUiOnly: true,
        yearFormat: 'YY',
      },
    });
  },
};
